/**
 * Created by Jerker Nord on 2020-02-11.
 */

export class BonusBunniesSpineBSymbol extends PIXI.spine.Spine{

    private _symPosition:PIXI.Point;

    constructor(spineData:PIXI.spine.core.SkeletonData) {
        super(spineData);
    }

    get symPosition():PIXI.Point {
        return this._symPosition;
    }

    set symPosition(value:PIXI.Point) {
        this._symPosition = value;
    }
}